import React from 'react';
import { Outlet } from 'react-router-dom';

const Administration: React.FC = () => {
  return (
    <Outlet/>
  );
};

export default Administration;